import { render, staticRenderFns } from "./NavbarReanmo.vue?vue&type=template&id=60013e8e&"
import script from "./NavbarReanmo.vue?vue&type=script&lang=js&"
export * from "./NavbarReanmo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports